<template>
  <div v-if="drcModeActive" class="w-full h-full pointer-events-all">
    <div class="flex flex-col mx-auto w-full controlPanel">
      <div class="flex flex-start py-4 h-full">
        <template
          v-if="
            ([0, 14].includes(this.config?.drone?.status?.mode_code) ||
              this.config?.drone?.status?.mode_code == undefined) &&
            $root.user.can([3, 4, 5], 'DEVICES.DRC.takeoff')
          "
        >
          <div @click="takeOffPoint()" class="btn_action takeoff_btn">
            <svg
              class="fill-current w-full"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 90.002 92.545"
            >
              <g transform="translate(3987.999 -7550.876)">
                <path
                  d="M45.086,47.422A77.686,77.686,0,0,1,20.62,43.467a49.367,49.367,0,0,1-9.482-4.17,27.823,27.823,0,0,1-7.879-6.631A15.79,15.79,0,0,1,.717,28.125a12.08,12.08,0,0,1-.669-5.138A15.769,15.769,0,0,1,4.594,13.87C8.646,9.61,14.541,6.383,22.613,4a74.407,74.407,0,0,1,15.18-2.732A2.493,2.493,0,0,1,37.4,3.5h.007c-1.721.195-3.486.449-5.247.759-5.768,1.012-13.17,2.756-19.269,7.3a17,17,0,0,0-6.063,7.41,10.966,10.966,0,0,0,1.094,9.688c2.782,4.492,7.864,7.949,15.536,10.57a66.274,66.274,0,0,0,20.4,3.424l-.015,0H44.4c.6.028,1.213.043,1.836.043A61.307,61.307,0,0,0,57.32,41.537,58.283,58.283,0,0,0,70.01,37.85c7.6-3.271,12.15-7.466,13.515-12.47,2.292-8.39-6.693-14.256-9.5-15.854A52,52,0,0,0,52.422,3.2a2.52,2.52,0,0,1-.2-1.922A72.7,72.7,0,0,1,68.878,4.451,49.519,49.519,0,0,1,79.855,9.324a23.466,23.466,0,0,1,8.418,8.357,12.72,12.72,0,0,1,1.148,10.153,18.43,18.43,0,0,1-5.981,8.239c-4.685,3.951-10.918,6.873-19.056,8.933a78.728,78.728,0,0,1-19.3,2.414h0Z"
                  transform="translate(-3987.999 7596)"
                />
                <g transform="translate(-3993 7591.71)">
                  <g>
                    <g>
                      <path
                        d="M67.114,14.334H60.585q.5,4.3.99,8.6H38.449q.5-4.3.989-8.6c-.823,0-6.545-.071-6.557-.062-.029.016-.9,5.051-1.346,7.465q-1.59,8.548-3.179,17.094c.8,0,8.248.159,8.267-.006q.546-4.741,1.091-9.487c.085-.742.171-1.488.256-2.232.017-.143.123-.961.114-.988s1.636,0,1.958,0H60.775c.279,0,1.146-.178,1.184.158q.231,1.992.46,3.983c.07.621.822,8.572,1,8.572H71.67q-2.281-12.246-4.556-24.5"
                      />
                    </g>
                    <path d="M49.451,46.947" />
                  </g>
                </g>
                <path
                  d="M24.871,51.2c0,2.356,1.564,4.266,3.494,4.266s3.494-1.91,3.494-4.266ZM30.835,1.25a3.067,3.067,0,0,0-4.941,0L3.659,28.4a4.958,4.958,0,0,0,0,6.033,3.067,3.067,0,0,0,4.941,0L28.365,10.3,48.129,34.433a3.067,3.067,0,0,0,4.941,0,4.958,4.958,0,0,0,0-6.033ZM31.858,51.2V4.266H24.871V51.2Z"
                  transform="translate(-3971.364 7550.876)"
                />
              </g>
            </svg>
            <div>{{ $e("Takeoff") }}</div>
          </div>

          <div
            v-if="this.config?.drone?.status?.mode_code == undefined"
            class="border-l border-g3 mx-2"
          ></div>
        </template>

        <template
          v-else-if="$root.user.can([3, 4, 5], 'DEVICES.DRC.keyboard_control')"
        >
          <div class="flex flex-col pt-3.5">
            <div class="flex">
              <div
                class="ml-2 controlPanelKeybord grid grid-rows-2 grid-cols-3 gap-0.5"
              >
                <div
                  @click="drcControl('ROOL-LEFT')"
                  :class="{ active: $root.controller.keyPressed('ROOL-LEFT') }"
                >
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("ROOL-LEFT")
                  }}</span>
                  <svg
                    class="fill-current"
                    width="12"
                    viewBox="0 0 75 89"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.8016 0.311534C28.3236 -1.11512 14.9556 5.14154 6.89855 16.4808L0.837321 12.1148L3.18121 32.4374L23.1998 28.223L16.6192 23.4829C16.6192 23.4829 16.6192 23.4829 16.6273 23.4887C17.1894 22.7598 25.9739 11.7965 39.966 13.1253C50.2908 14.1046 59.2083 21.3661 62.5575 31.5675C66.5916 30.9117 70.6117 30.2581 74.6459 29.6023C70.7046 13.6873 57.4583 1.96426 41.8016 0.311534Z"
                    />
                    <path d="M67 89L36 23L5 89L36 72.5L67 89Z" />
                  </svg>
                </div>
                <div
                  @click="drcControl('MOVE-UP')"
                  :class="{ active: $root.controller.keyPressed('MOVE-UP') }"
                >
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("MOVE-UP")
                  }}</span>
                  <svg
                    width="9"
                    class="fill-current -rotate-90"
                    viewBox="0 0 62 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z"
                    />
                  </svg>
                </div>
                <div
                  @click="drcControl('ROOL-RIGHT')"
                  :class="{ active: $root.controller.keyPressed('ROOL-RIGHT') }"
                >
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("ROOL-RIGHT")
                  }}</span>
                  <svg
                    class="fill-current"
                    width="12"
                    viewBox="0 0 75 89"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M33.3364 0.311534C46.8144 -1.11512 60.1824 5.14154 68.2394 16.4808L74.3007 12.1148L71.9568 32.4374L51.9382 28.223L58.5188 23.4829C58.5188 23.4829 58.5188 23.4829 58.5106 23.4887C57.9486 22.7598 49.1641 11.7965 35.1719 13.1253C24.8472 14.1046 15.9296 21.3661 12.5805 31.5675C8.5464 30.9117 4.52624 30.2581 0.49212 29.6023C4.43341 13.6873 17.6797 1.96426 33.3364 0.311534Z"
                    />
                    <path
                      d="M8.13798 89L39.138 23L70.138 89L39.138 72.5L8.13798 89Z"
                    />
                  </svg>
                </div>
                <div
                  @click="drcControl('MOVE-LEFT')"
                  :class="{ active: $root.controller.keyPressed('MOVE-LEFT') }"
                >
                  <svg
                    width="9"
                    class="fill-current rotate-180"
                    viewBox="0 0 62 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z"
                    />
                  </svg>
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("MOVE-LEFT")
                  }}</span>
                </div>
                <div
                  @click="drcControl('MOVE-DOWN')"
                  :class="{ active: $root.controller.keyPressed('MOVE-DOWN') }"
                >
                  <svg
                    width="9"
                    class="fill-current rotate-90"
                    viewBox="0 0 62 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z"
                    />
                  </svg>
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("MOVE-DOWN")
                  }}</span>
                </div>
                <div
                  @click="drcControl('MOVE-RIGHT')"
                  :class="{ active: $root.controller.keyPressed('MOVE-RIGHT') }"
                >
                  <svg
                    width="9"
                    class="fill-current"
                    viewBox="0 0 62 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z"
                    />
                  </svg>
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("MOVE-RIGHT")
                  }}</span>
                </div>
              </div>
              <div
                class="ml-2 controlPanelKeybord grid grid-rows-2 grid-cols-1 gap-0.5"
              >
                <div
                  @click="drcControl('DRONE-UP')"
                  :class="{ active: $root.controller.keyPressed('DRONE-UP') }"
                >
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("DRONE-UP")
                  }}</span>
                  <svg
                    width="15"
                    class="fill-current -rotate-90"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M36.85 99.89L100 50.18L37 0.110001V23.16C35.9 23.22 0.89 23.43 0 23.49V76.4H36.85V99.89Z"
                    />
                  </svg>
                </div>
                <div
                  @click="drcControl('DRONE-DOWN')"
                  :class="{ active: $root.controller.keyPressed('DRONE-DOWN') }"
                >
                  <svg
                    width="15"
                    class="fill-current rotate-90"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M36.85 99.89L100 50.18L37 0.110001V23.16C35.9 23.22 0.89 23.43 0 23.49V76.4H36.85V99.89Z"
                    />
                  </svg>
                  <span>{{
                    $root.controller.instruction2KeyboardLetter("DRONE-DOWN")
                  }}</span>
                </div>
              </div>
            </div>

            <!-- <div class="pt-7 ml-2 controlPanelKeybord">
              <div class="!py-[2px] !px-[10px] !w-full !bg-error hover:!bg-error/70"
                :class="{ '!bg-error/60': keyPressed('EMERGENCY') }" @click="emergency()">
                <svg class="fill-current mr-[8px]" width="10" viewBox="0 0 16 18" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 18V0H6V18H0ZM10 18V0H16V18H10Z" />
                </svg>
                Pause
                <span>spacebar</span>
              </div>
            </div> -->
          </div>
        </template>
        <template v-else>
          <div class="px-3"></div>
        </template>

        <DroneCompass :config="config" />

        <div class="pt-3.5 flex flex-col">
          <div class="flex">
            <template v-if="true">
              <div class="h-full flex flex-col">
                <div
                  class="flex items-end"
                  v-if="$root.user.can([3, 4, 5], 'DEVICES.DRC.edit_height')"
                >
                  <div class="controlPanelKeybord">
                    <div class="relative !w-[60px]">
                      <span>{{ $e("Hauteur") }}</span>
                      <input
                        type="number"
                        min="0"
                        max="999"
                        v-model="alt"
                        @change="altVerif"
                        id="alt"
                      />
                      <label for="alt">m</label>
                    </div>
                  </div>

                  <div
                    class="ml-0.5 controlPanelKeybord grid grid-rows-1 grid-cols-2 gap-0.5"
                  >
                    <div
                      @click="controlleAlt(-5)"
                      :class="{
                        active: $root.controller.keyPressed('HIGH-DOWN'),
                      }"
                    >
                      <span>{{
                        $root.controller.instruction2KeyboardLetter("HIGH-DOWN")
                      }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 75 75"
                      >
                        <rect
                          width="75"
                          height="15"
                          transform="translate(0 30)"
                          fill="#fff"
                        />
                      </svg>
                    </div>
                    <div
                      @click="controlleAlt(5)"
                      :class="{
                        active: $root.controller.keyPressed('HIGH-UP'),
                      }"
                    >
                      <span>{{
                        $root.controller.instruction2KeyboardLetter("HIGH-UP")
                      }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 75 75"
                      >
                        <rect
                          width="75"
                          height="15"
                          transform="translate(0 30)"
                          fill="#fff"
                        />
                        <rect
                          width="75"
                          height="15"
                          transform="translate(44.5) rotate(90)"
                          fill="#fff"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  class="flex items-end mt-0.5"
                  v-if="$root.user.can([3, 4, 5], 'DEVICES.DRC.edit_speed')"
                >
                  <div class="controlPanelKeybord">
                    <div class="relative !w-[60px]">
                      <input
                        type="number"
                        min="1"
                        max="20"
                        v-model="droneSpeed"
                        @change="droneSpeedVerif"
                        id="droneSpeed"
                      />
                      <label for="droneSpeed">m/s</label>
                      <span>{{ $e("Vitesse") }}</span>
                    </div>
                  </div>

                  <div
                    class="ml-0.5 controlPanelKeybord grid grid-rows-1 grid-cols-2 gap-0.5"
                  >
                    <div
                      @click="controlleSpeed(-1)"
                      :class="{
                        active: $root.controller.keyPressed('SPEED-DOWN'),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 75 75"
                      >
                        <rect
                          width="75"
                          height="15"
                          transform="translate(0 30)"
                          fill="#fff"
                        />
                      </svg>
                      <span>{{
                        $root.controller.instruction2KeyboardLetter(
                          "SPEED-DOWN"
                        )
                      }}</span>
                    </div>
                    <div
                      @click="controlleSpeed(1)"
                      :class="{
                        active: $root.controller.keyPressed('SPEED-UP'),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 75 75"
                      >
                        <rect
                          width="75"
                          height="15"
                          transform="translate(0 30)"
                          fill="#fff"
                        />
                        <rect
                          width="75"
                          height="15"
                          transform="translate(44.5) rotate(90)"
                          fill="#fff"
                        />
                      </svg>
                      <span>{{
                        $root.controller.instruction2KeyboardLetter("SPEED-UP")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="ml-0.5 controlPanelKeybord grid grid-rows-21 grid-cols-1 gap-0.5"
              >
                <div
                  @click="flyToPoint()"
                  :class="{ 'opacity-30': newPositionEntity == false }"
                  class="flex justify-center items-center p-3 !w-[92px] h-[24px] btn_action ml-2"
                  v-if="$root.user.can([3, 4, 5], 'DEVICES.DRC.fly_to')"
                >
                  <span> {{ $e("fly to") }} </span>
                  <svg
                    width="25"
                    viewBox="0 0 37 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="27" cy="10" r="10" fill="white" />
                    <path
                      d="M1 9C0.447715 9 -4.82823e-08 9.44772 0 10C4.82823e-08 10.5523 0.447715 11 1 11L1 9ZM12.7071 10.7071C13.0976 10.3166 13.0976 9.68342 12.7071 9.29289L6.34315 2.92893C5.95262 2.53841 5.31946 2.53841 4.92893 2.92893C4.53841 3.31946 4.53841 3.95262 4.92893 4.34315L10.5858 10L4.92893 15.6569C4.53841 16.0474 4.53841 16.6805 4.92893 17.0711C5.31946 17.4616 5.95262 17.4616 6.34315 17.0711L12.7071 10.7071ZM1 11L12 11L12 9L1 9L1 11Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <span class="flex relative justify-between">
                  <div
                    @click="lookAtPoint()"
                    :class="{ 'opacity-30': newPositionEntity == false }"
                    class="flex justify-center items-center p-3 !w-[45px] h-[24px] btn_action ml-2"
                    v-if="
                      $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_point')
                    "
                  >
                    <svg
                      width="25"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 158.14 126.86"
                    >
                      <circle
                        cx="123.4"
                        cy="62.03"
                        r="25.87"
                        style="fill: #e2e1e1"
                      />
                      <line
                        x1="1.5"
                        y1="90.32"
                        x2="155.14"
                        y2="125.36"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 10;
                          stroke-width: 3px;
                        "
                      />
                      <line
                        x1="81.96"
                        y1="1.95"
                        x2="1.5"
                        y2="90.32"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 10;
                          stroke-width: 3px;
                        "
                      />
                      <line
                        x1="155.14"
                        y1="123.72"
                        x2="155.14"
                        y2="34.07"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 6px;
                        "
                      />
                      <line
                        x1="83.1"
                        y1="3"
                        x2="155.14"
                        y2="34.07"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 6px;
                        "
                      />
                      <line
                        x1="83.1"
                        y1="92.64"
                        x2="155.14"
                        y2="123.72"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 6px;
                        "
                      />
                      <line
                        x1="1.5"
                        y1="90.32"
                        x2="156.29"
                        y2="33.74"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 10;
                          stroke-width: 3px;
                        "
                      />
                      <line
                        x1="83.1"
                        y1="3"
                        x2="83.1"
                        y2="92.64"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 6px;
                        "
                      />
                      <line
                        x1="1.5"
                        y1="90.32"
                        x2="82.33"
                        y2="93.91"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 10;
                          stroke-width: 3px;
                        "
                      />
                      <polygon
                        points="155.14 125.36 83.1 92.64 83.1 3 155.14 34.07 155.14 125.36"
                        style="fill: rgba(255, 255, 255, 0.18)"
                      />
                    </svg>
                  </div>
                  <div
                    @click="lookAtGround()"
                    :class="{ 'opacity-30': newPositionEntity == false }"
                    class="flex justify-center items-center p-3 !w-[45px] h-[24px] btn_action ml-2"
                    style="margin: 0 0 0 2px; width: 45px"
                    v-if="
                      $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_ground')
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 63.8 51.87"
                    >
                      <polygon
                        points="56.16 51.24 18.3 50.48 28.61 40.06 62.53 39.98 56.16 51.24"
                        style="fill: #fff; opacity: 0.6"
                      />
                      <circle
                        cx="39.1"
                        cy="10.97"
                        r="10.97"
                        style="fill: #e2e1e1"
                      />
                      <line
                        x1="28.13"
                        y1="39.61"
                        x2=".64"
                        y2="8.18"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 1.58;
                          stroke-width: 1.27px;
                        "
                      />
                      <line
                        x1="56.16"
                        y1="50.54"
                        x2="62.53"
                        y2="39.98"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 2.54px;
                        "
                      />
                      <line
                        x1="28.61"
                        y1="40.06"
                        x2="62.53"
                        y2="39.98"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 2.54px;
                        "
                      />
                      <line
                        x1="18.3"
                        y1="50.48"
                        x2="56.16"
                        y2="50.54"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 2.54px;
                        "
                      />
                      <line
                        x1=".64"
                        y1="8.18"
                        x2="63.02"
                        y2="39.84"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 1.58;
                          stroke-width: 1.27px;
                        "
                      />
                      <line
                        x1="28.61"
                        y1="40.06"
                        x2="18.3"
                        y2="50.48"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-width: 2.54px;
                        "
                      />
                      <line
                        x1=".64"
                        y1="8.18"
                        x2="17.97"
                        y2="51.02"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 1.58;
                          stroke-width: 1.27px;
                        "
                      />
                      <rect
                        x="37.79"
                        y="23.24"
                        width="2.63"
                        height="7.4"
                        style="fill: #e2e1e1"
                      />
                      <rect
                        x="37.79"
                        y="33"
                        width="2.63"
                        height="7.4"
                        style="fill: #e2e1e1"
                      />
                      <rect
                        x="37.79"
                        y="42.42"
                        width="2.63"
                        height="3.7"
                        style="fill: #e2e1e1"
                      />
                      <line
                        x1=".64"
                        y1="8.18"
                        x2="56.16"
                        y2="51.24"
                        style="
                          fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 1.58;
                          stroke-width: 1.27px;
                        "
                      />
                    </svg>
                  </div>
                  <span
                    :class="{ 'opacity-30': newPositionEntity == false }"
                    v-if="
                      $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_ground') ||
                      $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_point')
                    "
                    style="
                      left: 42%;
                      color: #d3d3d3;
                      font-size: 10px;
                      top: 28px;
                      position: absolute;
                    "
                  >
                    {{ $e("look at") }}
                  </span>
                </span>
              </div>

              <div
                class="relative right-[2px] top-[-21px]"
                @click.prevent="infoGoTo()"
                v-if="
                  $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_ground') ||
                  $root.user.can([3, 4, 5], 'DEVICES.DRC.look_at_point')
                "
              >
                <span class="i" :class="{ '!bg-flyingeye': openHelp }">
                  ?
                </span>
              </div>
            </template>
          </div>

          <div class="flex"></div>
        </div>
      </div>

      <!-- //////////////////////////// -->
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import API from "@/utils/API.js";
import Map from "@/utils/Map";
import Timer from "@/utils/Timer";
import DroneCompass from "@/partials/Device/Template/Drone/DroneCompass.vue";

export default {
  name: "Flight_ControlePanel",
  props: {
    config: Object,
  },
  components: {
    DroneCompass,
  },
  setup() {
    let alt = 60;
    if ($root.frontconfig?.drone_drc_max_altitude != undefined) {
      if ($root.frontconfig.drone_drc_max_altitude < alt) {
        alt = $root.frontconfig.drone_drc_max_altitude;
      }
    }

    return {
      Seq: ref(0),
      timerSeq: ref(false),
      alt: ref(alt),
      newPositionEntity: ref(false),
      droneSpeed: ref(5),
      handler: ref(false),
      longitude: ref(0),
      latitude: ref(0),
      AbsHeight: ref(0),
      CartoHeight: ref(0),
      RthRelHeight: ref(0),
      pressedKey: ref([]),
      openHelp: ref(false),
      drcModeActive: ref(true),
    };
  },

  async mounted() {
    this.initKeys();

    if (this.config?.dock?.status?.drc_state == 0) {
      let data = await API.put("drcmodeenter", {
        DevId: this.config.deviceFamilly.this_dev_id,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Activation du mode DRC"),
        success: () => {
          this.drcModeActive = true;
        },
        error: () => {
          this.drcModeActive = false;
          console.error("Erreur pour activer le mode DRC");
        },
      };
    }

    var clock = 0;
    Timer.addRequest("drcHeartBeat" + this.config.deviceFamilly.this_dev_id, {
      timer: async () => {
        clock++;
        if (this.drcModeActive && !this.$root.debug && clock % 5 == 0) {
          await API.put(`drcheartbeat`, {
            Seq: this.Seq,
            Ts: 20,
            DevId: this.config.deviceFamilly.this_dev_id,
          });
        }
      },
    });

    this.initClickMap();
  },

  async unmounted() {
    Timer.closeRequest("drcHeartBeat" + this.config.deviceFamilly.this_dev_id);

    // this.$root.confirm_open({
    //   message: this.$e("Voulez-vous désactiver le mode DRC ?"),
    //   true: async () => {
    //     let data = await API.put("drcmodeexit", {
    //       DevId: this.config.deviceFamilly.this_dev_id
    //     });

    //     this.$root.msg_replie[data.command] = {
    //       id: data.command,
    //       name: "Désactivation du mode DRC",
    //     };
    //   },
    //   false: () => { },
    // });

    this?.handler?.destroy();

    if (this.newPositionEntity !== false) {
      Map.getViewer().entities.remove(this.newPositionEntity);
    }
  },

  methods: {
    initClickMap() {
      if (Map.getViewer()?.scene == undefined) {
        setTimeout(() => {
          this.initClickMap();
        }, 2000);
        return;
      }
      this.handler = new Cesium.ScreenSpaceEventHandler(
        Map.getViewer().scene.canvas
      );
      this.handler.setInputAction(
        this.placePoint,
        Cesium.ScreenSpaceEventType.RIGHT_CLICK
      );
    },

    initKeys() {
      this.$root.controller.keysToAction = {
        fr: {
          Z: {
            name: "MOVE-UP",
            action: () => {
              this.drcControl("MOVE-UP");
            },
            type: "onPressed",
          },
          Q: {
            name: "MOVE-LEFT",
            action: () => {
              this.drcControl("MOVE-LEFT");
            },
            type: "onPressed",
          },
          S: {
            name: "MOVE-DOWN",
            action: () => {
              this.drcControl("MOVE-DOWN");
            },
            type: "onPressed",
          },
          D: {
            name: "MOVE-RIGHT",
            action: () => {
              this.drcControl("MOVE-RIGHT");
            },
            type: "onPressed",
          },
          A: {
            name: "ROOL-LEFT",
            action: () => {
              this.drcControl("ROOL-LEFT");
            },
            type: "onPressed",
          },
          E: {
            name: "ROOL-RIGHT",
            action: () => {
              this.drcControl("ROOL-RIGHT");
            },
            type: "onPressed",
          },
          R: {
            name: "DRONE-UP",
            action: () => {
              this.drcControl("DRONE-UP");
            },
            type: "onPressed",
          },
          F: {
            name: "DRONE-DOWN",
            action: () => {
              this.drcControl("DRONE-DOWN");
            },
            type: "onPressed",
          },
          W: {
            name: "HIGH-DOWN",
            action: () => {
              this.controlleAlt(-5);
            },
            type: "onPressedWithRepeat",
          },
          X: {
            name: "HIGH-UP",
            action: () => {
              this.controlleAlt(5);
            },
            type: "onPressedWithRepeat",
          },
          C: {
            name: "SPEED-DOWN",
            action: () => {
              this.controlleSpeed(-1);
            },
            type: "onPressedWithRepeat",
          },
          V: {
            name: "SPEED-UP",
            action: () => {
              this.controlleSpeed(1);
            },
            type: "onPressedWithRepeat",
          },
          // 'EMERGENCY': ' '
        },
        en: {
          W: {
            name: "MOVE-UP",
            action: () => {
              this.drcControl("MOVE-UP");
            },
            type: "onPressed",
          },
          A: {
            name: "MOVE-LEFT",
            action: () => {
              this.drcControl("MOVE-LEFT");
            },
            type: "onPressed",
          },
          S: {
            name: "MOVE-DOWN",
            action: () => {
              this.drcControl("MOVE-DOWN");
            },
            type: "onPressed",
          },
          D: {
            name: "MOVE-RIGHT",
            action: () => {
              this.drcControl("MOVE-RIGHT");
            },
            type: "onPressed",
          },
          Q: {
            name: "ROOL-LEFT",
            action: () => {
              this.drcControl("ROOL-LEFT");
            },
            type: "onPressed",
          },
          E: {
            name: "ROOL-RIGHT",
            action: () => {
              this.drcControl("ROOL-RIGHT");
            },
            type: "onPressed",
          },
          R: {
            name: "DRONE-UP",
            action: () => {
              this.drcControl("DRONE-UP");
            },
            type: "onPressed",
          },
          F: {
            name: "DRONE-DOWN",
            action: () => {
              this.drcControl("DRONE-DOWN");
            },
            type: "onPressed",
          },
          Z: {
            name: "HIGH-DOWN",
            action: () => {
              this.controlleAlt(-5);
            },
            type: "onPressedWithRepeat",
          },
          X: {
            name: "HIGH-UP",
            action: () => {
              this.controlleAlt(5);
            },
            type: "onPressedWithRepeat",
          },
          C: {
            name: "SPEED-DOWN",
            action: () => {
              this.controlleSpeed(-1);
            },
            type: "onPressedWithRepeat",
          },
          V: {
            name: "SPEED-UP",
            action: () => {
              this.controlleSpeed(1);
            },
            type: "onPressedWithRepeat",
          },
          // 'EMERGENCY': ' '
        },
      };
    },

    infoGoTo() {
      toast.info(
        `
        <div class="flex items-center">
          <svg width="35" class="fill-current mx-2" viewBox="0 0 29 42" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14 42C21.732 42 28 35.732 28 28V14C28 6.268 21.732 0 14 0C6.268 0 0 6.268 0 14V28C0 35.732 6.268 42 14 42ZM26 20H2V28C2 34.627 7.373 40 14 40C20.627 40 26 34.627 26 28V20ZM15.883 14.583C15.615 14.761 15.315 14.885 15 14.949V18H21.734L15.883 14.583ZM17 10.603V12.5C17 12.635 16.989 12.769 16.968 12.9L25.699 18H26V15.86L17 10.603ZM13 6.05103V2.04099C6.841 2.54899 2 7.709 2 14V18H13V14.949C12.523 14.852 12.081 14.617 11.732 14.268C11.263 13.799 11 13.163 11 12.5V8.5C11 7.837 11.263 7.20099 11.732 6.73199C12.081 6.38299 12.523 6.14803 13 6.05103ZM15 4.802V6.05103C15.477 6.14803 15.919 6.38299 16.268 6.73199C16.685 7.14899 16.939 7.69801 16.99 8.28101L25.991 13.538C25.958 12.668 25.833 11.821 25.624 11.008L15 4.802ZM13 12.5V8.5C13 8.367 13.053 8.24 13.146 8.146C13.24 8.053 13.367 8 13.5 8H14.5C14.633 8 14.76 8.053 14.854 8.146C14.947 8.24 15 8.367 15 8.5V12.5C15 12.633 14.947 12.76 14.854 12.854C14.76 12.947 14.633 13 14.5 13H13.5C13.367 13 13.24 12.947 13.146 12.854C13.053 12.76 13 12.633 13 12.5ZM15 2.48599L24.371 7.96002C22.449 4.66602 19.003 2.37099 15 2.04099V2.48599Z" />
          </svg>
          <span>` +
          this.$e("Clique droit sur la carte pour placer un point") +
          `</span>
        </div>
      `,
        this.$root.toastConfig
      );
    },

    altVerif() {
      let max = $root.frontconfig?.drone_drc_max_altitude || 1500;

      if (this.alt < 0 || isNaN(parseInt(this.alt))) {
        this.alt = 0;
      } else if (this.alt > max) {
        this.alt = max;
      }
    },

    controlleAlt(v) {
      this.alt += v;
      this.altVerif();
    },

    droneSpeedVerif() {
      if (this.droneSpeed < 1 || isNaN(parseInt(this.droneSpeed))) {
        this.droneSpeed = 1;
      } else if (this.droneSpeed > 20) {
        this.droneSpeed = 20;
      }
    },

    placePoint(click) {
      if (!this.config.full_screen_active) return;

      var position = Map.getViewer().scene.pickPosition(click.position);
      var cartographic = Cesium.Cartographic.fromCartesian(position);

      if (Cesium.defined(position)) {
        this.longitude = Cesium.Math.toDegrees(cartographic.longitude);
        this.latitude = Cesium.Math.toDegrees(cartographic.latitude);
        this.CartoHeight = cartographic.height;
        this.AbsHeight = cartographic.height + this.alt;
        this.RthRelHeight = this.alt;

        if (this.newPositionEntity !== false) {
          Map.getViewer().entities.remove(this.newPositionEntity);
        }

        this.newPositionEntity = Map.getViewer().entities.add({
          name: this.$e("Controle manuelle"),
          position: new Cesium.CallbackProperty(() => {
            this.AbsHeight = cartographic.height + this.alt;
            return Cesium.Cartesian3.fromDegrees(
              this.longitude,
              this.latitude,
              this.AbsHeight
            );
          }, false),
          zIndex: 999,
          ellipsoid: {
            radii: new Cesium.Cartesian3(1, 1, 1),
            material: Cesium.Color.fromBytes(255, 230, 0).withAlpha(1),
          },

          ellipse: {
            semiMinorAxis: 0.5,
            semiMajorAxis: 0.5,
            maximumRadius: 50,
            minimumRadius: 0.5,
            material: Cesium.Color.fromBytes(255, 230, 0).withAlpha(1),
          },

          polyline: {
            positions: new Cesium.CallbackProperty(() => {
              return Cesium.Cartesian3.fromDegreesArrayHeights([
                this.longitude,
                this.latitude,
                this.AbsHeight,
                this.longitude,
                this.latitude,
                0,
              ]);
            }, false),
            width: 3,
            material: new Cesium.PolylineDashMaterialProperty({
              color: Cesium.Color.fromBytes(255, 230, 0).withAlpha(1),
            }),
          },

          label: {
            text: `#${this.config.drone.id} - ${this.config.drone.name}`,
            font: "600 14px Inter, sans-serif",
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.fromCssColorString("#303030"),
            showBackground: true,
            backgroundColor: Cesium.Color.fromCssColorString("#303030"),
            outlineWidth: 1,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.TOP,
            eyeOffset: new Cesium.Cartesian3(0, -1, 0),
            scale: 1,
            scaleByDistance: new Cesium.NearFarScalar(0, 1, 5000, 0.0),
            totalScale: 1,
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
              0,
              5000
            ),
          },
        });
      } else {
        toast.error(
          this.$e("Erreur pour récupérer la position de votre clic"),
          this.$root.toastConfig
        );
      }
    },

    controlleSpeed(v) {
      this.droneSpeed += v;
      this.droneSpeedVerif();
    },

    /** --------------------- */

    async emergency() {
      let data = await API.get("drcemergencystop", {
        DevId: this.config.deviceFamilly.this_dev_id,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Arrêt d'urgence"),
      };
    },

    async flyToPoint() {
      if (this.newPositionEntity == false) {
        toast.error(
          this.$e("Placer un point avant de demander un déplacement"),
          this.$root.toastConfig
        );
        return;
      }

      let data = await API.put("flytopoint", {
        DevId: this.config.deviceFamilly.this_dev_id,
        Lat: this.latitude,
        Lng: this.longitude,
        Hei: this.AbsHeight,
        Speed: this.droneSpeed,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Vol vers le point"),
      };
    },

    async lookAtPoint() {
      if (this.newPositionEntity == false) {
        toast.error(
          this.$e("Placer un point avant de demander de regarder le point"),
          this.$root.toastConfig
        );
        return;
      }

      let data = await API.put("cameralookat", {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        Lat: this.latitude,
        Lng: this.longitude,
        Hei: this.AbsHeight,
        Locked: "false",
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Regarder le point"),
      };
    },

    async lookAtGround() {
      if (this.newPositionEntity == false) {
        toast.error(
          this.$e("Placer un point avant de demander de regarder le point"),
          this.$root.toastConfig
        );
        return;
      }

      let data = await API.put("cameralookat", {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        Lat: this.latitude,
        Lng: this.longitude,
        Hei: 0,
        Locked: "false",
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Regarder le point"),
      };
    },

    async takeOffPoint() {
      if (
        this.config?.dock?.status?.longitude == undefined ||
        this.config?.dock?.status?.latitude == undefined ||
        this.config?.dock?.status?.height == undefined ||
        this.config?.dock?.status?.longitude == 0 ||
        this.config?.dock?.status?.latitude == 0
      ) {
        toast.error(
          this.$e("Les coordonnées du dock sont inconnu"),
          this.$root.toastConfig
        );
        return;
      }

      let data = await API.put("takeofftopoint", {
        DevId: this.config.deviceFamilly.this_dev_id,
        Lat: this.config.dock.status.latitude,
        Lng: this.config.dock.status.longitude,
        Hei: this.config.dock.status.height + this.alt,
        SecuHei: this.alt,
        RthHei: this.alt,
        CmdHei: this.alt,
        Speed: this.droneSpeed,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Décollage"),
      };
    },

    async drcControl(input) {
      let axe = "";
      let up = "";

      switch (input) {
        case "MOVE-UP":
          axe = "X";
          up = "";
          break;
        case "MOVE-DOWN":
          axe = "X";
          up = "-";
          break;
        case "MOVE-LEFT":
          axe = "Y";
          up = "-";
          break;
        case "MOVE-RIGHT":
          axe = "Y";
          up = "";
          break;
        case "ROOL-LEFT":
          axe = "W";
          up = "-";
          break;
        case "ROOL-RIGHT":
          axe = "W";
          up = "";
          break;
        case "DRONE-UP":
          axe = "H";
          up = "";
          break;
        case "DRONE-DOWN":
          axe = "H";
          up = "-";
          break;
        default:
          break;
      }

      if (![0, 14].includes(this.config.drone.status.mode_code)) {
        let data = API.put("drcdronecontrol", {
          DevId: this.config.deviceFamilly.this_dev_id,
          Seq: this.Seq,
          X: axe == "X" ? up + this.droneSpeed : 0,
          Y: axe == "Y" ? up + this.droneSpeed : 0,
          H: axe == "H" ? up + this.droneSpeed : 0,
          W: axe == "W" ? up + 45 : 0,
        });

        this.Seq++;
        this.resetSequance();
      }
    },

    /** --------------------- */

    visualKey(key, press) {
      if (press && !this.pressedKey.includes(key)) {
        this.pressedKey.push(this.keyboard2Instruction(key));
      } else {
        this.pressedKey = this.pressedKey.filter((el) => {
          return el != this.keyboard2Instruction(key);
        });
      }
    },

    keyboard2Instruction(value) {
      return Object.keys(this.keys).find((key) => this.keys[key] === value);
    },

    resetSequance() {
      if (this.timerSeq !== false) {
        clearTimeout(this.timerSeq);
      }

      this.timerSeq = setTimeout(() => {
        this.Seq = 0;
      }, 1000);
    },
  },

  watch: {
    "config.full_screen_active": {
      handler: function (val) {
        if (val) this.initKeys();
      },
    },
  },
};
</script>
